import AddPaymentMethodModal from '@features/enterprise/components/AddPaymentMethodModal';
import PaymentMethods from '@features/payments/components/PaymentCardDetail/PaymentCardDetail';
import { useGetPaymantDetails } from '@features/payments/hooks/useGetPaymantDetails';
import { Add } from '@mui/icons-material';
import { Box, Button, CircularProgress, Divider, Stack, Typography } from '@mui/material';
import { white } from '@styles/colors';
import React, { useState } from 'react';
import EnterpriseBillingCycle from './EnterpriseBillingCycle';
import ReactivateSubscriptionModal from '@features/enterprise/components/ReactivateSubscriptionModal';
import { useGetCurrentPlan } from '@features/payments/hooks/useGetCurrentPlan';

function EnterprisePaymentMethods() {
  const [addPaymentMethodModal, setAddPaymentMethodModal] = useState(false);
  const [showReactivateModal, setShowReactivateModal] = useState(false);
  const { paymentInfo, isPaymentInfoLoading } = useGetPaymantDetails();
  const { currentPlanData } = useGetCurrentPlan();
  return (
    <Stack
      spacing={3}
      bgcolor={white}
      p={3}
      borderRadius="8px"
      width="100%"
      alignItems="center"
    >
      {isPaymentInfoLoading ? (
        <CircularProgress />
      ) : (
        <Stack width="100%" spacing={6}>
          {currentPlanData?.status !== 200 && (
            <Button onClick={() => setShowReactivateModal(true)} variant='contained' color='success' sx={{ width: 'fit-content', alignSelf: "end" }}>Activate Subscription</Button>
          )}
          <EnterpriseBillingCycle />
          <Divider />
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h5" gutterBottom>
              Payment Methods
            </Typography>
            {paymentInfo?.status !== 202 && (
              <Button
                startIcon={<Add />}
                size="small"
                onClick={() => setAddPaymentMethodModal(true)}
                variant="contained"
                sx={{ flexShrink: 0 }}
              >
                Add New Payment Method
              </Button>
            )}
          </Stack>
          {paymentInfo?.status === 201 &&
            paymentInfo?.object &&
            paymentInfo?.object?.data && (
            <PaymentMethods
              cards={paymentInfo?.object?.data}
              defaultSource={paymentInfo?.default_source}
            />
          )}
        </Stack>
      )}
      {addPaymentMethodModal && (
        <AddPaymentMethodModal
          handleClose={() => setAddPaymentMethodModal(false)}
        />
      )}
      {showReactivateModal && (
        <ReactivateSubscriptionModal
          open={showReactivateModal}
          handleClose={() => setShowReactivateModal(false)}
        />
      )}
    </Stack>
  );
}

export default EnterprisePaymentMethods;
